import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from 'utils/api';
import {
  Alert,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  Row,
  Col
} from "reactstrap";
import { Dots } from 'react-preloaders';

const imageHeader = {
  borderRadius: '40px'
};
const loginHeader = {
  fontWeight: 500,
  fontSize: '20px'
};
const alertStyle = {
  fontSize: '13px'
};

const ForgotPassword = props => {
  let history = useHistory();

  const [openAlert, setOpenAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formState, setFormState] = useState({ 
    values: { emailAddress: '' },
    errorColor: 'success',
    errorMessage: 'Your password reset request was successful. Please check your email to get the reset password link. You will be redirected in login page within 5 seconds.'
  });

  const emailValidation = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const handleAlertClose = () => {
    setOpenAlert(false);
  };

  const handleChange = (event, value, param) => {
    event.persist();

    setFormState(formState => ({
        ...formState,
        values: {
            ...formState.values,
            [param]: value
        },
        touched: {
            ...formState.touched,
            [param]: true
        }
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    
    if (formState.values.emailAddress !== '') {
      if (emailValidation.test(String(formState.values.emailAddress).toLowerCase())) {
        setLoading(true);

        axios.post('merchant/forgotpassword/?emailAddress=' + formState.values.emailAddress).then(response => {
          if (response.data.status !== 0) {
            setLoading(false);
            setFormState(formState => ({
              ...formState,
              errorColor: 'success',
              errorMessage: 'Your password reset request was successful. Please check your email to get the reset password link. You will be redirected in login page within 5 seconds.'
            }));

            setTimeout(function() {
              history.push('/auth/login');
            }, 5000);
          } else {
            setFormState(formState => ({
              ...formState,
              errorColor: 'danger',
              errorMessage: response.data.message
            }));   
            setLoading(false);
          }
    
          setOpenAlert(true);
        }).catch(error => {
          setFormState(formState => ({
            ...formState,
            errorColor: 'danger',
            errorMessage: 'There is a problem sending reset password instructions in your email. Please try again later.'
          }));
          
          setOpenAlert(true);
          setLoading(false);
        })
      }
      else {
        setFormState(formState => ({
          ...formState,
          errorColor: 'danger',
          errorMessage: 'Please enter a valid email address format.'
        }));

        setOpenAlert(true);
        setLoading(false);
      }
    } 
    else {
      setFormState(formState => ({
        ...formState,
        errorColor: 'danger',
        errorMessage: 'Email address is required.'
      }));

      setOpenAlert(true);
      setLoading(false);
    }
  }

  document.body.style.overflow = '';
  document.body.style.position = 'relative';

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <p style={{textAlign:"center"}}><Media object width="100" style={imageHeader} src={require("assets/img/brand/forgot_password.png")} alt="Forgot Password" /></p>
            <div className="text-center mb-4" style={loginHeader}>
              Forgot Password
            </div>
            <div className="text-center text-muted mb-4">
              <small>Forgot your password? Don't worry! Just fill in your email and we'll send you a link to reset your password.</small>
            </div>
            <hr />
            <Form role="form">
              {loading && <Dots background="rgba(192,192,192,0.3)" customLoading={loading} color="#000099"/>}
              { 
                openAlert && 
                (<Alert style={alertStyle} color={formState.errorColor} isOpen={openAlert} toggle={handleAlertClose} fade={true}>
                    {formState.errorMessage}
                </Alert>) 
              }
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input placeholder="Email Address" type="text" pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z0-9.-]{1,}[.]{1}[a-zA-Z0-9]{2,}" title="Please enter a valid email address." onChange={event => handleChange(event, event.target.value, event.target.name)} onKeyPress={event => { if (event.key === 'Enter') { handleSubmit(event) }}} name="emailAddress" value={formState.values.emailAddress || ''} required data-error="Email Address is required" autoComplete="off"/>
                </InputGroup>
              </FormGroup>
              <div className="text-center">
                <Input type="submit" value="Reset Password"
                  onClick={handleSubmit}
                  disabled={!formState.values.emailAddress}
                />
              </div> 
            </Form>
          </CardBody>
        </Card>
        <Row className="mt-3">
          <Col className="text-right" xs="12">
            <a
              href="/auth/login"
            >
              <small>Return to Log In</small>
            </a>
          </Col>
        </Row>
      </Col>
    </>
  );
}

export default ForgotPassword;
